import React, { useState, useEffect } from "react";
import AuthModal from "./AuthModal";
import { Link } from "react-router-dom";
import axios from "axios";

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const [showProfileModal, setShowProfileModal] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [count, setCount] = useState(0);

  // Budget dropdown
  const [budgetOpen, setBudgetOpen] = useState(false);

  // Projects dropdown
  const [projectsOpen, setProjectsOpen] = useState(false);

  // Categories and subcategories
  const [cat, setcatsubcat] = useState([]);
  const [cats, setcatsubcats] = useState([]);

  useEffect(() => {
    checkLoginState();
    fetchData();
    fetcatsubcat();

    const checkMobile = () => {
      setIsMobile(window.innerWidth < 992);
    };

    checkMobile();

    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // --------------------------------
  // FETCH LOVED DESIGNS COUNT
  // --------------------------------
  const fetchData = async () => {
    const userId =
      localStorage.getItem("userId") ||
      JSON.parse(localStorage.getItem("user") || "null")?.id;

    if (!userId) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);

      const res = await axios.get(
        `https://api.squareandangle.pranatigroup.in/api/admin/loved/${userId}`
      );

      setCount(res.data.rows?.length || 0);
    } catch (e) {
      setError(
        e?.response?.data?.message || "Failed to load design ideas"
      );
    } finally {
      setLoading(false);
    }
  };

  // --------------------------------
  // FETCH CATEGORY + SUBCATEGORY
  // --------------------------------
  const fetcatsubcat = async () => {
    try {
      const res = await axios.get(
        "https://api.squareandangle.pranatigroup.in/api/admin/designideasall"
      );

      setcatsubcat(res.data.category || []);
      setcatsubcats(res.data.subcategory || []);
    } catch (error) {
      console.error("Failed to load categories:", error);
    }
  };

  // --------------------------------
  // LOGIN STATE
  // --------------------------------
  const checkLoginState = () => {
    const user = localStorage.getItem("user");

    if (user && user !== "undefined") {
      try {
        setIsLoggedIn(true);
        setUserData(JSON.parse(user));
      } catch (e) {
        console.error("Error parsing user data", e);

        setIsLoggedIn(false);
        setUserData(null);

        localStorage.removeItem("user");
        localStorage.removeItem("userId");
      }
    } else {
      setIsLoggedIn(false);
      setUserData(null);
    }
  };

  // --------------------------------
  // MOBILE MENU
  // --------------------------------
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setBudgetOpen(false);
    setProjectsOpen(false);
  };

  // --------------------------------
  // DISPLAY NAME
  // --------------------------------
  const getDisplayName = () => {
    const name = userData?.name;

    if (name?.trim()) return name.trim();

    const email = userData?.email;

    if (email?.trim()) return email.trim();

    return "Profile";
  };

  // --------------------------------
  // STYLES
  // --------------------------------
  const styles = {
    header: {
      position: "sticky",
      top: 0,
      left: 0,
      width: "100%",
      zIndex: 9999,
      background: "#D5BB9B",
      borderBottom: "1px solid #eeeeee",
      boxShadow: "0 3px 20px rgba(0,0,0,0.06)",
    },

    container: {
      width: "100%",
      maxWidth: "1400px",
      margin: "0 auto",
      padding: isMobile ? "0 18px" : "0 30px",
    },

    headerRow: {
      minHeight: isMobile ? "75px" : "88px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },

    logoArea: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      textDecoration: "none",
    },

    logo: {
      height: isMobile ? "58px" : "68px",
      width: isMobile ? "58px" : "68px",
      objectFit: "cover",
      borderRadius: "50%",
      border: "2px solid #b08d57",
      padding: "3px",
      background: "#fff",
    },

    brandArea: {
      display: "flex",
      flexDirection: "column",
      lineHeight: 1.1,
    },

    brandName: {
      fontSize: isMobile ? "17px" : "20px",
      fontWeight: 800,
      color: "#1e293b",
      letterSpacing: "0.3px",
      margin: 0,
    },

    brandTagline: {
      fontSize: isMobile ? "9px" : "10px",
      color: "#a47b45",
      letterSpacing: "1.5px",
      textTransform: "uppercase",
      marginTop: "5px",
      fontWeight: 600,
    },

    nav: {
      display: "flex",
      alignItems: "center",
      gap: "5px",
      margin: 0,
      padding: 0,
      listStyle: "none",
    },

    navLink: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      gap: "5px",
      padding: "11px 13px",
      color: "#334155",
      textDecoration: "none",
      fontSize: "14px",
      fontWeight: 600,
      letterSpacing: "0.1px",
      borderRadius: "6px",
      transition: "all 0.25s ease",
      whiteSpace: "nowrap",
    },

    navLinkHover: {
      background: "#f8f5ef",
      color: "#9b7441",
    },

    budgetWrapper: {
      position: "relative",
    },

    budgetButton: {
      border: "none",
      background: "transparent",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "6px",
      padding: "11px 13px",
      color: "#334155",
      fontSize: "14px",
      fontWeight: 600,
      borderRadius: "6px",
    },

    dropdown: {
      position: "absolute",
      top: "calc(100% + 10px)",
      left: 0,
      width: "225px",
      background: "#ffffff",
      border: "1px solid #eeeeee",
      borderRadius: "10px",
      boxShadow: "0 15px 40px rgba(0,0,0,0.12)",
      padding: "8px",
      zIndex: 10000,
    },

    dropdownLink: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      padding: "12px 13px",
      color: "#334155",
      textDecoration: "none",
      fontSize: "14px",
      fontWeight: 600,
      borderRadius: "7px",
      transition: "all 0.2s ease",
    },

    cart: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "42px",
      height: "42px",
      borderRadius: "50%",
      background: "#f8f5ef",
      color: "#9b7441",
      textDecoration: "none",
      fontSize: "17px",
      marginLeft: "5px",
    },

    badge: {
      position: "absolute",
      top: "-3px",
      right: "-3px",
      minWidth: "18px",
      height: "18px",
      padding: "0 4px",
      background: "#b08d57",
      color: "#ffffff",
      borderRadius: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "10px",
      fontWeight: 800,
      border: "2px solid #ffffff",
    },

    joinButton: {
      border: "1px solid #b08d57",
      background: "#b08d57",
      color: "#ffffff",
      padding: "10px 19px",
      borderRadius: "6px",
      fontSize: "13px",
      fontWeight: 700,
      cursor: "pointer",
      marginLeft: "8px",
      transition: "all 0.25s ease",
      letterSpacing: "0.3px",
    },

    profileButton: {
      display: "flex",
      alignItems: "center",
      gap: "9px",
      border: "1px solid #e8dfd2",
      background: "#faf8f4",
      color: "#334155",
      padding: "7px 13px 7px 8px",
      borderRadius: "25px",
      cursor: "pointer",
      marginLeft: "7px",
      maxWidth: "170px",
    },

    profileCircle: {
      width: "31px",
      height: "31px",
      borderRadius: "50%",
      background: "#b08d57",
      color: "#ffffff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "13px",
      fontWeight: 700,
      flexShrink: 0,
    },

    profileName: {
      fontSize: "13px",
      fontWeight: 700,
      maxWidth: "100px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },

    mobileToggle: {
      width: "45px",
      height: "42px",
      border: "1px solid #e8dfd2",
      borderRadius: "7px",
      background: "#faf8f4",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "5px",
      cursor: "pointer",
    },

    mobileLine: {
      width: "20px",
      height: "2px",
      background: "#334155",
      borderRadius: "2px",
    },

    overlay: {
      position: "fixed",
      inset: 0,
      background: "rgba(15,23,42,0.45)",
      backdropFilter: "blur(2px)",
      zIndex: 9998,
    },

    sidebar: {
      position: "fixed",
      top: 0,
      right: 0,
      width: "min(330px, 88vw)",
      height: "100vh",
      background: "#ffffff",
      zIndex: 10000,
      boxShadow: "-10px 0 35px rgba(0,0,0,0.15)",
      padding: "25px 22px",
      overflowY: "auto",
    },

    sidebarHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      paddingBottom: "22px",
      marginBottom: "10px",
      borderBottom: "1px solid #eeeeee",
    },

    closeButton: {
      width: "36px",
      height: "36px",
      borderRadius: "50%",
      border: "1px solid #eeeeee",
      background: "#f8f8f8",
      color: "#334155",
      fontSize: "20px",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },

    mobileNav: {
      listStyle: "none",
      padding: 0,
      margin: 0,
    },

    mobileNavItem: {
      borderBottom: "1px solid #f0f0f0",
    },

    mobileNavLink: {
      display: "flex",
      alignItems: "center",
      padding: "15px 5px",
      color: "#334155",
      textDecoration: "none",
      fontSize: "15px",
      fontWeight: 600,
    },

    profileModal: {
      position: "fixed",
      top: isMobile ? "78px" : "92px",
      right: isMobile ? "12px" : "25px",
      width: isMobile ? "calc(100% - 24px)" : "300px",
      maxWidth: "300px",
      background: "#ffffff",
      borderRadius: "12px",
      boxShadow: "0 15px 45px rgba(0,0,0,0.15)",
      border: "1px solid #eeeeee",
      padding: "15px",
      zIndex: 10001,
    },

    profileCard: {
      padding: "18px",
      borderRadius: "10px",
      background: "#faf8f4",
      border: "1px solid #eadfce",
    },

    profileAvatar: {
      width: "45px",
      height: "45px",
      borderRadius: "50%",
      background: "#b08d57",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "17px",
      fontWeight: 700,
    },
  };

  // --------------------------------
  // NAV HOVER
  // --------------------------------
  const navHover = (e, enter) => {
    Object.assign(
      e.currentTarget.style,
      enter
        ? {
            background: styles.navLinkHover.background,
            color: styles.navLinkHover.color,
          }
        : {
            background: "transparent",
            color: styles.navLink.color,
          }
    );
  };

  // --------------------------------
  // DROPDOWN HOVER
  // --------------------------------
  const dropdownHover = (e, enter) => {
    Object.assign(
      e.currentTarget.style,
      enter
        ? {
            background: "#f8f5ef",
            color: "#9b7441",
          }
        : {
            background: "#ffffff",
            color: "#334155",
          }
    );
  };

  // --------------------------------
  // DESKTOP LINK
  // --------------------------------
  const desktopLink = (to, label, icon = null) => (
    <li key={to}>
      <Link
        to={to}
        onClick={closeMobileMenu}
        style={styles.navLink}
        onMouseEnter={(e) => navHover(e, true)}
        onMouseLeave={(e) => navHover(e, false)}
      >
        {icon && <i className={`fa ${icon}`}></i>}
        {label}
      </Link>
    </li>
  );

  // --------------------------------
  // MOBILE LINK
  // --------------------------------
  const mobileLink = (to, label, icon = null) => (
    <li key={to} style={styles.mobileNavItem}>
      <Link
        to={to}
        onClick={closeMobileMenu}
        style={styles.mobileNavLink}
      >
        {icon && (
          <i
            className={`fa ${icon}`}
            style={{
              width: "28px",
              color: "#b08d57",
              fontSize: "15px",
            }}
          ></i>
        )}

        {label}
      </Link>
    </li>
  );

  // --------------------------------
  // DESKTOP NAVIGATION
  // --------------------------------
  const desktopNavItems = (
    <ul style={styles.nav}>

      {desktopLink("/", "Home", "fa-home")}

      {desktopLink("/about", "About", "fa-info-circle")}

      {desktopLink("/city_base", "City", "fa-map-marker")}

      {desktopLink("/sample_projects", "Prototype ", "fa-picture-o")}

      {/* ==============================
          PROJECTS DROPDOWN
      ============================== */}
      <li style={styles.budgetWrapper}>
        <button
          onClick={() => {
            setProjectsOpen((prev) => !prev);
            setBudgetOpen(false);
          }}
          style={styles.budgetButton}
          onMouseEnter={(e) => navHover(e, true)}
          onMouseLeave={(e) => navHover(e, false)}
        >
          <i className="fa fa-building"></i>

          Services

          <i
            className="fa fa-angle-down"
            style={{
              fontSize: "11px",
              transform: projectsOpen
                ? "rotate(180deg)"
                : "none",
              transition: "0.2s",
            }}
          ></i>
        </button>

        {projectsOpen && (
          <ul
            style={{
              ...styles.dropdown,
              width: "290px",
              maxHeight: "500px",
              overflowY: "auto",
            }}
          >
           {cat.map((item, index) => (
  <li
    key={item.id || index}
    style={{
      listStyle: "none",
    }}
  >
    <Link
      to={`/detail/${item.id}`}
      onClick={() => setProjectsOpen(false)}
      style={{
        display: "block",
        padding: "10px 13px 7px",
        color: "#9b7441",
        textDecoration: "none",
        fontSize: "13px",
        fontWeight: 800,
        borderBottom: "1px solid #f1ede7",
      }}
    >
      {item.category}
    </Link>
  </li>
))}

            {cat.length === 0 && (
              <li
                style={{
                  listStyle: "none",
                  padding: "15px",
                  color: "#888",
                  fontSize: "13px",
                  textAlign: "center",
                }}
              >
                No projects available
              </li>
            )}
          </ul>
        )}
      </li>

      {desktopLink(
        "/video_gallery",
        "Gallery",
        "fa-picture-o"
      )}

      
      <li style={styles.budgetWrapper}>
        <button
          onClick={() => {
            setBudgetOpen((prev) => !prev);
            setProjectsOpen(false);
          }}
          style={styles.budgetButton}
          onMouseEnter={(e) => navHover(e, true)}
          onMouseLeave={(e) => navHover(e, false)}
        >
          <i className="fa fa-calculator"></i>

          Budget

          <i
            className="fa fa-angle-down"
            style={{
              fontSize: "11px",
              transform: budgetOpen
                ? "rotate(180deg)"
                : "none",
              transition: "0.2s",
            }}
          ></i>
        </button>

        {budgetOpen && (
          <ul style={styles.dropdown}>
            <li>
              <Link
                to="/wardrobe_calculator"
                onClick={() => {
                  closeMobileMenu();
                }}
                style={styles.dropdownLink}
                onMouseEnter={(e) =>
                  dropdownHover(e, true)
                }
                onMouseLeave={(e) =>
                  dropdownHover(e, false)
                }
              >
                <i className="fa fa-bed"></i>

                Home interior Budget
              </Link>
            </li>

            <li>
              <Link
                to="/kitchen"
                onClick={() => {
                  closeMobileMenu();
                }}
                style={styles.dropdownLink}
                onMouseEnter={(e) =>
                  dropdownHover(e, true)
                }
                onMouseLeave={(e) =>
                  dropdownHover(e, false)
                }
              >
                <i className="fa fa-cutlery"></i>

                Kitchen Budget
              </Link>
            </li>
          </ul>
        )}
      </li>

      {desktopLink(
        "/contact",
        "Contact",
        "fa-phone"
      )}

      {desktopLink(
        "/blogin",
        "Blog",
        "fa-pencil-square-o"
      )}

     
      <li>
        <Link
          to="/design_ideas"
          onClick={closeMobileMenu}
          style={styles.cart}
          title="Loved Designs"
        >
          <i className="fa fa-heart"></i>

          <span style={styles.badge}>
            {loading ? "..." : count}
          </span>
        </Link>
      </li>

      {/* PROFILE / JOIN */}
      <li>
        {isLoggedIn ? (
          <button
            onClick={() => setShowProfileModal(true)}
            style={styles.profileButton}
          >
            <span style={styles.profileCircle}>
              {getDisplayName()
                .charAt(0)
                .toUpperCase()}
            </span>

            <span style={styles.profileName}>
              {getDisplayName()}
            </span>

            <i
              className="fa fa-angle-down"
              style={{
                color: "#9b7441",
              }}
            ></i>
          </button>
        ) : (
          <button
            onClick={() =>
              setShowAuthModal(true)
            }
            style={styles.joinButton}
            onMouseEnter={(e) => {
              e.currentTarget.style.background =
                "#8d6839";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background =
                "#b08d57";
            }}
          >
            Join Us
          </button>
        )}
      </li>
    </ul>
  );

 
  const mobileNavItems = (
    <ul style={styles.mobileNav}>

      {mobileLink("/", "Home", "fa-home")}

      {mobileLink(
        "/about",
        "About",
        "fa-info-circle"
      )}

      {mobileLink(
        "/city_base",
        "City",
        "fa-map-marker"
      )}

       {mobileLink(
        "/sample_projects",
        "Prototype",
        "fa-picture-o"
      )}

     
      <li style={styles.mobileNavItem}>
        <button
          onClick={() =>
            setProjectsOpen((prev) => !prev)
          }
          style={{
            ...styles.mobileNavLink,
            width: "100%",
            background: "transparent",
            border: "none",
            cursor: "pointer",
            textAlign: "left",
          }}
        >
          <i
            className="fa fa-building"
            style={{
              width: "28px",
              color: "#b08d57",
            }}
          ></i>

          <span style={{ flex: 1 }}>
            Services
          </span>

          <i
            className="fa fa-angle-down"
            style={{
              transform: projectsOpen
                ? "rotate(180deg)"
                : "none",
              transition: "0.2s",
            }}
          ></i>
        </button>

        {projectsOpen && (
          <div
            style={{
              background: "#faf8f4",
              padding:
                "5px 10px 12px 33px",
            }}
          >
           {cat.map((item, index) => (
  <li
    key={item.id || index}
    style={{
      listStyle: "none",
    }}
  >
    <Link
      to={`/detail/${item.id}`}
      onClick={() => setProjectsOpen(false)}
      style={{
        display: "block",
        padding: "10px 13px 7px",
        color: "#9b7441",
        textDecoration: "none",
        fontSize: "13px",
        fontWeight: 800,
        borderBottom: "1px solid #f1ede7",
      }}
    >
      {item.category}
    </Link>
  </li>
))}
            {cat.length === 0 && (
              <div
                style={{
                  padding: "10px 5px",
                  color: "#888",
                  fontSize: "13px",
                }}
              >
                No projects available
              </div>
            )}
          </div>
        )}
      </li>

      {mobileLink(
        "/video_gallery",
        "Gallery",
        "fa-picture-o"
      )}

      {/* ==============================
          MOBILE BUDGET
      ============================== */}
      <li style={styles.mobileNavItem}>
        <button
          onClick={() =>
            setBudgetOpen((prev) => !prev)
          }
          style={{
            ...styles.mobileNavLink,
            width: "100%",
            background: "transparent",
            border: "none",
            cursor: "pointer",
            textAlign: "left",
          }}
        >
          <i
            className="fa fa-calculator"
            style={{
              width: "28px",
              color: "#b08d57",
            }}
          ></i>

          <span style={{ flex: 1 }}>
            Budget
          </span>

          <i
            className="fa fa-angle-down"
            style={{
              transform: budgetOpen
                ? "rotate(180deg)"
                : "none",
              transition: "0.2s",
            }}
          ></i>
        </button>

        {budgetOpen && (
          <div
            style={{
              background: "#faf8f4",
              padding:
                "5px 10px 8px 33px",
            }}
          >
            <Link
              to="/wardrobe_calculator"
              onClick={closeMobileMenu}
              style={{
                ...styles.mobileNavLink,
                padding:
                  "11px 5px",
                fontSize: "14px",
              }}
            >
              Home interior Budget
            </Link>

            <Link
              to="/kitchen"
              onClick={closeMobileMenu}
              style={{
                ...styles.mobileNavLink,
                padding:
                  "11px 5px",
                fontSize: "14px",
              }}
            >
              Kitchen Budget
            </Link>
          </div>
        )}
      </li>

      {mobileLink(
        "/contact",
        "Contact",
        "fa-phone"
      )}

      {mobileLink(
        "/blogin",
        "Blog",
        "fa-pencil-square-o"
      )}

      {/* LOVED DESIGNS */}
      <li style={styles.mobileNavItem}>
        <Link
          to="/design_ideas"
          onClick={closeMobileMenu}
          style={styles.mobileNavLink}
        >
          <i
            className="fa fa-heart"
            style={{
              width: "28px",
              color: "#b08d57",
            }}
          ></i>

          Loved Designs

          <span
            style={{
              marginLeft: "auto",
              background: "#b08d57",
              color: "#fff",
              minWidth: "23px",
              height: "23px",
              borderRadius: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "11px",
              fontWeight: 700,
            }}
          >
            {loading ? "..." : count}
          </span>
        </Link>
      </li>

      {/* PROFILE / JOIN */}
      <li
        style={{
          marginTop: "20px",
        }}
      >
        {isLoggedIn ? (
          <button
            onClick={() => {
              setShowProfileModal(true);
              closeMobileMenu();
            }}
            style={{
              width: "100%",
              border:
                "1px solid #eadfce",
              background: "#faf8f4",
              color: "#334155",
              padding: "12px",
              borderRadius: "8px",
              fontWeight: 700,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              textAlign: "left",
            }}
          >
            <span
              style={styles.profileCircle}
            >
              {getDisplayName()
                .charAt(0)
                .toUpperCase()}
            </span>

            <span>
              {getDisplayName()}
            </span>
          </button>
        ) : (
          <button
            onClick={() => {
              setShowAuthModal(true);
              closeMobileMenu();
            }}
            style={{
              width: "100%",
              border: "none",
              background: "#b08d57",
              color: "#ffffff",
              padding: "13px",
              borderRadius: "7px",
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            Join Us
          </button>
        )}
      </li>
    </ul>
  );

  // --------------------------------
  // RETURN
  // --------------------------------
  return (
    <>
      <AuthModal
        showModal={showAuthModal}
        setshowModal={setShowAuthModal}
      />

      {/* HEADER */}
      <header style={styles.header}>
        <div style={styles.container}>
          <div style={styles.headerRow}>

            {/* LOGO */}
            <Link
              to="/"
              style={styles.logoArea}
            >
              <img
                src="assets/images/download.webp"
                alt="Square & Angle"
                style={styles.logo}
              />

              <div
                style={styles.brandArea}
              >
                <p
                  style={styles.brandName}
                >
                  Square & Angle
                </p>

                <span
                  style={
                    styles.brandTagline
                  }
                >
                  Interior Design Studio
                </span>
              </div>
            </Link>

            {/* DESKTOP NAVIGATION */}
            {!isMobile && (
              <nav>
                {desktopNavItems}
              </nav>
            )}

            {/* MOBILE BUTTON */}
            {isMobile && (
              <button
                onClick={toggleMobileMenu}
                style={
                  styles.mobileToggle
                }
                aria-label="Open navigation menu"
              >
                <span
                  style={
                    styles.mobileLine
                  }
                ></span>

                <span
                  style={
                    styles.mobileLine
                  }
                ></span>

                <span
                  style={
                    styles.mobileLine
                  }
                ></span>
              </button>
            )}
          </div>
        </div>
      </header>

      {/* ==============================
          MOBILE SIDEBAR
      ============================== */}
      {isMobile &&
        isMobileMenuOpen && (
          <>
            <div
              style={styles.overlay}
              onClick={
                closeMobileMenu
              }
            ></div>

            <aside
              style={styles.sidebar}
            >
              <div
                style={
                  styles.sidebarHeader
                }
              >
                <div>
                  <div
                    style={{
                      fontSize: "17px",
                      fontWeight: 800,
                      color: "#1e293b",
                    }}
                  >
                    Square & Angle
                  </div>

                  <div
                    style={{
                      fontSize: "9px",
                      color: "#b08d57",
                      letterSpacing:
                        "1.3px",
                      marginTop: "4px",
                      fontWeight: 700,
                    }}
                  >
                    INTERIOR DESIGN
                    STUDIO
                  </div>
                </div>

                <button
                  onClick={
                    closeMobileMenu
                  }
                  style={
                    styles.closeButton
                  }
                  aria-label="Close menu"
                >
                  &times;
                </button>
              </div>

              {mobileNavItems}
            </aside>
          </>
        )}

      {/* ==============================
          PROFILE MODAL
      ============================== */}
      {showProfileModal && (
        <>
          <div
            onClick={() =>
              setShowProfileModal(false)
            }
            style={{
              position: "fixed",
              inset: 0,
              background:
                "rgba(15,23,42,0.12)",
              zIndex: 10000,
            }}
          />

          <div
            style={
              styles.profileModal
            }
          >
            <button
              onClick={() =>
                setShowProfileModal(false)
              }
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                width: "27px",
                height: "27px",
                borderRadius: "50%",
                border: "none",
                background: "#f1f1f1",
                color: "#666",
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              &times;
            </button>

            <div
              style={
                styles.profileCard
              }
            >
              <div
                style={{
                  display: "flex",
                  alignItems:
                    "center",
                  gap: "12px",
                  marginBottom:
                    "15px",
                }}
              >
                <div
                  style={
                    styles.profileAvatar
                  }
                >
                  {getDisplayName()
                    .charAt(0)
                    .toUpperCase()}
                </div>

                <div>
                  <div
                    style={{
                      color: "#1e293b",
                      fontSize: "15px",
                      fontWeight: 800,
                    }}
                  >
                    {getDisplayName()}
                  </div>

                  <div
                    style={{
                      color: "#b08d57",
                      fontSize: "10px",
                      fontWeight: 700,
                      textTransform:
                        "uppercase",
                      letterSpacing:
                        "0.8px",
                      marginTop: "3px",
                    }}
                  >
                    Customer
                  </div>
                </div>
              </div>

              {userData?.email && (
                <div
                  style={{
                    borderTop:
                      "1px solid #eadfce",
                    paddingTop:
                      "12px",
                    fontSize: "13px",
                    color: "#475569",
                  }}
                >
                  <span
                    style={{
                      color: "#9b7441",
                      fontWeight: 700,
                    }}
                  >
                    Email
                  </span>

                  <div
                    style={{
                      marginTop: "4px",
                      wordBreak:
                        "break-word",
                    }}
                  >
                    {userData.email}
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Header;
